import { contentApi } from '@/lib/api'

export interface Post {
  id: string
  title: string
  slug: string
  summary: string | null
  content: string | null
  status: 'draft' | 'published' | 'archived'
  author_id: string
  cover_image_url: string | null
  view_count: number
  like_count: number
  comment_count: number
  created_at: string
  updated_at: string
  published_at: string | null
  taxonomies?: Array<{
    id: string
    name: string
    slug: string
    type: string
  }>
}

export interface PostComment {
  id: string
  content: string
  parent_id: string | null
  user_id: string
  user_name: string
  user_avatar: string | null
  like_count: number
  created_at: string
  updated_at: string
}

export interface ListPostsParams {
  page?: number
  limit?: number
  status?: string
  author_id?: string
  taxonomy_id?: string
  search?: string
}

export const postsService = {
  // Listar posts
  async listPosts(params?: ListPostsParams) {
    const response = await contentApi.get('/content/posts', { params })
    return response.data
  },

  // Obter post por ID
  async getPost(id: string) {
    const response = await contentApi.get(`/content/posts/${id}`)
    return response.data
  },

  // Obter post por slug
  async getPostBySlug(slug: string) {
    const response = await contentApi.get(`/content/posts/${slug}`)
    return response.data
  },

  // Dar like em post
  async likePost(id: string) {
    const response = await contentApi.post(`/content/posts/${id}/like`)
    return response.data
  },

  // Remover like
  async unlikePost(id: string) {
    const response = await contentApi.delete(`/content/posts/${id}/like`)
    return response.data
  },

  // Verificar se deu like
  async checkLiked(id: string) {
    const response = await contentApi.get(`/content/posts/${id}/liked`)
    return response.data
  },

  // Listar comentários
  async getComments(id: string, params?: { page?: number; limit?: number }) {
    const response = await contentApi.get(`/content/posts/${id}/comments`, { params })
    return response.data
  },

  // Adicionar comentário
  async addComment(id: string, content: string, parent_id?: string) {
    const response = await contentApi.post(`/content/posts/${id}/comments`, {
      content,
      parent_id,
    })
    return response.data
  },

  // Editar comentário
  async updateComment(postId: string, commentId: string, content: string) {
    const response = await contentApi.put(`/content/posts/${postId}/comments/${commentId}`, {
      content,
    })
    return response.data
  },

  // Deletar comentário
  async deleteComment(postId: string, commentId: string) {
    const response = await contentApi.delete(`/content/posts/${postId}/comments/${commentId}`)
    return response.data
  },

  // Verificar se curtiu comentário
  async checkCommentLiked(postId: string, commentId: string) {
    const response = await contentApi.get(`/content/posts/${postId}/comments/${commentId}/liked`)
    return response.data
  },

  // Curtir comentário
  async likeComment(postId: string, commentId: string) {
    const response = await contentApi.post(`/content/posts/${postId}/comments/${commentId}/like`)
    return response.data
  },

  // Descurtir comentário
  async unlikeComment(postId: string, commentId: string) {
    const response = await contentApi.delete(`/content/posts/${postId}/comments/${commentId}/like`)
    return response.data
  },

  // Incrementar visualização
  async incrementView(id: string) {
    const response = await contentApi.post(`/content/posts/${id}/view`)
    return response.data
  },
}
